<template>
  <v-form ref="form">
    <v-row class="pb-12 mt-mb-12">
      <v-col cols="12">
        <p class="form__title primary--text mb-8">
          DADOS DO TRIBUNAL
        </p>
      </v-col>
      <v-col cols="12" class="pb-6">
          <v-switch
            class="pa-0 ma-0 justify-self-center d-inline-block new-insurance-form__switch"
            v-model="form.ativo"
            inset
            hide-details
            dense
            color="secondary"
          />
          <p class="pl-1 mb-0 d-inline-block darkBluishGray--text body-2">
            {{ statusSwitch }}
          </p>
        </v-col>
      <v-col cols="12">
        <BaseFormSelect
          id-element="typeCourt"
          :items="segmentList"
          placeholder="Selecione"
          v-model="form.segmento"
          required
          :rules="[requiredInput]"
          label-text="Tipo de Tribunal"
          validate-on-blur
          :item-text="displaySegmentName"
          item-value="id"
          :return-object="true"
        />
      </v-col>
      <v-col cols="12" md="9" class="pr-md-5">
        <BaseFormInput
          id-element="nameCourt"
          placeholder="Inserir"
          v-model="form.nome"
          required
          :rules="[requiredInput, requiredLengthN(form.nome, 3)]"
          label-text="Nome do Tribunal"
        />
      </v-col>
      <v-col cols="12" md="3">
        <BaseFormInput
          id-element="initialsCourt"
          placeholder="Inserir"
          v-model="form.sigla"
          required
          :rules="[requiredInput, requiredLengthN(form.sigla, 2)]"
          label-text="Sigla"
        />
      </v-col>
      <v-col cols="12">
        <BaseFormInput
          id-element="codeCourt"
          placeholder="Inserir"
          v-model="form.site"
          :rules="[validURL]"
          :upper-case="false"
          label-text="Site"
        />
      </v-col>
      <v-col cols="12" md="3">
        <BaseFormInput
          id-element="codeCourt"
          placeholder="Inserir"
          v-model="form.codigo"
          required
          :rules="[requiredInput, requiredLength2]"
          label-text="Código de Referência"
        />
      </v-col>
      <v-col cols="12" md="6" class="px-md-5">
        <BaseFormInput
          id-element="regionCourt"
          placeholder="Inserir"
          v-model="form.regiao_atuacao"
          required
          :rules="[requiredInput, requiredLengthN(form.regiao_atuacao, 3)]"
          label-text="Região de Atuação"
        />
      </v-col>
      <v-col cols="12" md="3">
        <BaseFormSelect
          id-element="ufCourt"
          placeholder="Selecione"
          v-model="form.uf"
          :items="brazilianStates"
          required
          :rules="[requiredInput]"
          label-text="UF"
          item-text="sigla"
          item-value="sigla"
          :return-object="true"
        />
      </v-col>
      <v-col cols="12" md="7">
        <div
          class="court-form__disclaimer yellow d-flex align-center justify-center"
        >
          <p class="primary--text mb-0 font-weight-bold caption">
            * Código de Referência preenchido irá compor parte do número do
            processo judicial.
          </p>
        </div>
      </v-col>
    </v-row>
    <BaseFooter>
      <v-row>
        <v-spacer />
        <v-col cols="12" sm="4" md="3" xl="2" class="pr-sm-5 pb-5 pb-sm-0">
          <BaseButton
            v-html="'CANCELAR'"
            class="pink white--text"
            width="100%"
            @click="previousPage"
          />
        </v-col>
        <v-col cols="12" sm="4" md="3" xl="2">
          <BaseButton
            v-html="textButton"
            class="secondary"
            width="100%"
            @click="submit"
          />
        </v-col>
      </v-row>
    </BaseFooter>
  </v-form>
</template>
<script>
const mockListCourt = [
  {
    nome: "TRIBUNAL DE JUSTIÇA",
    id: 1
  }
];
import { requiredInput, validURL } from "@/utils/rules.js";
import { brazilianStates } from "@/utils/utils.js";

export default {
  data: () => ({
    requiredInput,
    brazilianStates,
    listCourt: mockListCourt,
    validURL
  }),
  computed: {
    statusSwitch() {
      const status = this.form.ativo ? "Ativo" : "Inativo";
      return `Status: ${status}`;
    }
  },
  methods: {
    displaySegmentName(value) {
      return `${value.codigo} - ${value.nome}`;
    },

    submit() {
      if (this.$refs.form.validate()) this.$emit("submit", this.form);
    },
    previousPage() {
      this.$emit("previous-page");
    },
    requiredLength2(value) {
      return (
        !value ||
        value.toString().length === 2 ||
        "O código deve ter 2 caracteres"
      );
    },
    requiredLengthN(value, number) {
      return (
        !value ||
        value.toString().length >= number ||
        `Elemento deve ter pelo menos ${number} caracteres`
      );
    }
  },
  props: {
    form: {
      type: Object
    },
    textButton: {
      type: String,
      default: "ADICIONAR"
    },
    previousRoute: {
      type: String,
      default: "list court"
    },
    routerId: {
      type: String,
      default: null
    },
    segmentList: {
      type: Array
    }
  }
};
</script>
<style lang="sass">
.court-form__
  &disclaimer
    border-radius: 4px
    height: 35px
</style>
